import React from 'react'
import classNames from 'classnames'
import styles from './Title.module.scss'

interface Props {
  type: 'h1' | 'h2' | 'h3'
  children: React.ReactNode
}

export const Title = ({ type, children }: Props) => (
  <div className={classNames(styles.root, styles[type])}>
    {children}
  </div>
)
